<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    width="800px"
    :before-close="handleClose"
    center
    class="children-physique-dialog"
    :append-to-body="true"
  >
    <div class="dialog-content">
      <div class="dialog-header">
        <div class="header-title">选择儿童体质辨识类型</div>
      </div>
      
      <div class="option-list">
        <div 
          v-for="option in computedOptions" 
          :key="option.value"
          :class="[
            'option-item', 
            { 
              'selected': selectedType === option.value,
              'disabled': option.disabled 
            }
          ]"
          @click="handleSelectOption(option)"
        >
          <div class="option-icon">
            <img v-if="option.disabled && option.iconLocked" :src="option.iconLocked" alt="" />
            <img v-else-if="option.icon" :src="option.icon" alt="" />
          </div>
          <div :class="['option-content', { 'selected': selectedType === option.value }]">
            <div class="option-desc">{{ option.desc }}</div>
          </div>
          
          <!-- 三角形选中状态 -->
          <div v-if="selectedType === option.value" class="triangle-check">
            <i class="el-icon-check"></i>
          </div>
          
          <div v-if="option.disabled" class="disabled-mask" @mouseenter="showTooltip(option, $event)" @mouseleave="hideTooltip">
            <!-- 不显示问号图标，使用上锁的图片作为状态指示 -->
          </div>
        </div>
      </div>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" class="cancel-btn">取消</el-button>
      <el-button 
        type="primary" 
        @click="handleConfirm"
        :disabled="!selectedType"
        class="confirm-btn"
      >
        确定
      </el-button>
    </div>
    
    <!-- 自定义tooltip -->
    <div 
      v-if="tooltipVisible" 
      class="custom-tooltip"
      :style="{ left: tooltipPosition.x + 'px', top: tooltipPosition.y + 'px' }"
    >
      {{ tooltipContent }}
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ChildrenPhysiqueDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 导入图片 - 正常状态
    const iconM = require('@/assets/images/home/icon-m@2x.png');
    const iconS = require('@/assets/images/home/icon-s@2x.png');
    const iconB = require('@/assets/images/home/icon-b@2x.png');
    
    // 导入图片 - 上锁状态
    const iconMs = require('@/assets/images/home/icon-ms@2x.png');
    const iconSs = require('@/assets/images/home/icon-ss@2x.png');
    const iconBs = require('@/assets/images/home/icon-bs@2x.png');
    
    return {
      selectedType: '',
      tooltipVisible: false,
      tooltipContent: '',
      tooltipPosition: { x: 0, y: 0 },
      options: [
        {
          value: 'infant',
          desc: '0-3岁',
          icon: iconM,
          iconLocked: iconMs,
          disabled: false,
          tooltip: '您的账号暂未开通此类型体质辨识如有需要请联系客服进行开通'
        },
        {
          value: 'children',
          desc: '4-6岁',
          icon: iconS,
          iconLocked: iconSs,
          disabled: false,
          tooltip: '您的账号暂未开通此类型体质辨识如有需要请联系客服进行开通'
        },
        {
          value: 'adolescent',
          desc: '7-12岁',
          icon: iconB,
          iconLocked: iconBs,
          disabled: true,
          tooltip: '您的账号暂未开通此类型体质辨识如有需要请联系客服进行开通'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      authoritys: (state) => state.user.authoritys,
    }),
    // 根据用户权限控制选项是否可用
    computedOptions() {
      return this.options.map(option => {
        const customerManageTypes = this.userInfo?.customerManageTypes || [];
        const manageTypesArray = typeof customerManageTypes === 'object' 
          ? customerManageTypes 
          : customerManageTypes.split(',');
        
        // 根据不同年龄组设置不同的权限要求
        let hasPermission = true;
        switch(option.value) {
          case 'infant': // 0-3岁
            // 假设需要特定权限才能使用0-3岁体质辨识
            hasPermission = manageTypesArray.indexOf('16') > -1; 
            break;
          case 'children': // 4-6岁  
            hasPermission = manageTypesArray.indexOf('17') > -1; 
            break;
          case 'adolescent': // 7-12岁
            // 可以设置不同的权限要求，这里作为示例暂时禁用
            hasPermission = manageTypesArray.indexOf('18') > -1; 
            break;
          default:
            hasPermission = true;
        }
        
        return {
          ...option,
          disabled: !hasPermission
        };
      });
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.selectedType = '';
      }
    }
  },
  methods: {
    handleSelectOption(option) {
      if (option.disabled) {
        return;
      }
      this.selectedType = option.value;
    },
    handleConfirm() {
      if (!this.selectedType) {
        this.$message.warning('请选择体质辨识类型');
        return;
      }
      const selectedOption = this.computedOptions.find(opt => opt.value === this.selectedType);
      this.$emit('confirm', {
        type: this.selectedType,
        desc: selectedOption.desc
      });
    },
    handleClose() {
      this.selectedType = '';
      this.hideTooltip();
      this.$emit('close');
    },
    showTooltip(option, event) {
      if (!option.disabled) return;
      
      this.tooltipContent = option.tooltip;
      this.tooltipPosition = {
        x: event.clientX + 10,
        y: event.clientY - 10
      };
      this.tooltipVisible = true;
    },
    hideTooltip() {
      this.tooltipVisible = false;
    }
  }
}
</script>

<style lang="less" scoped>
.children-physique-dialog {
  /deep/ .el-dialog {
    border-radius: 8px;
    
    .el-dialog__footer {
      padding: 16px 24px 24px;
      border-top: 1px solid #e1efee;
    }
  }
}

.dialog-content {
  padding: 20px 30px;
  .dialog-header {
    text-align: center;
    margin-bottom: 32px;
    
    .header-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2226;
      margin-bottom: 8px;
    }
    
    .header-desc {
      font-size: 14px;
      color: #666;
    }
  }
  
  .option-list {
    display: flex;
    justify-content: space-around;

    .option-item {
      display: flex;
      flex-direction: column;
      position: relative;
      border-radius: 12px;
      border: 1px solid #DEE0E3;
      cursor: pointer;
      transition: all 0.3s ease;
      width: 170px;
      height: 190px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      &:hover:not(.disabled) {
        border-color: #19b2ad;
        background-color: #f0fffe;
      }
      
      &.selected {
        border-color: #19b2ad;
        background-color: #f0fffe;
        
        .option-radio .radio-icon {
          color: #19b2ad;
          font-weight: bold;
        }
      }
      
      &.disabled {
        cursor: not-allowed;
        // opacity: 0.6;
        // background-color: #f5f7fa;
        
        .disabled-mask {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: transparent;
          cursor: help;
          z-index: 1;
        }
      }
      
      .option-icon {
        
        width: 100%;
        height: 130px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        
        img {
          width: 54px;
        }
        
        i {
          font-size: 24px;
          color: #19b2ad;
        }
      }
      
      .option-content {
        
        flex: 1;
        background-color: #DEE0E3;
        border-radius: 0 0 10px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        &.selected {
          background-color: #19B2AD;
        }
        
        .option-title {
          font-size: 16px;
          font-weight: 600;
          color: #1f2226;
          margin-bottom: 4px;
        }
        
        .option-desc {
          font-weight: 500;
          font-size: 18px;
          color: #333333;
        }
      }
      
      // 禁用状态下的文字颜色
      &.disabled .option-content .option-desc {
        color: #999999;
      }
      
      // 三角形选中状态
      .triangle-check {
        position: absolute;
        top: 0;
        right: 0;
        width: 40px;
        height: 40px;
        background-color: #19b2ad;
        border-top-right-radius: 10px;
        clip-path: polygon(100% 0%, 0% 0%, 100% 100%);
        
        i {
          position: absolute;
          top: 6px;
          right: 6px;
          font-size: 14px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}

.dialog-footer {
  text-align: right;
  
  .cancel-btn {
    margin-right: 12px;
    padding: 10px 20px;
    border: 1px solid #dcdfe6;
    color: #606266;
    
    &:hover {
      border-color: #c0c4cc;
      color: #409eff;
    }
  }
  
  .confirm-btn {
    padding: 10px 24px;
    background-color: #19b2ad;
    border-color: #19b2ad;
    
    &:hover:not(:disabled) {
      background-color: #13a09b;
      border-color: #13a09b;
    }
    
    &:disabled {
      background-color: #c0c4cc;
      border-color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}

.custom-tooltip {
  position: fixed;
  z-index: 9999;
  background-color: #303133;
  color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  max-width: 200px;
  word-wrap: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}
</style>
